export default {
  decodeBase64Content(base64Content){
    let commonContent = base64Content.replace(/\s/g, '+');
    commonContent = Buffer.from(commonContent, 'base64').toString();
    return commonContent;
  },
  encodeBase64Content(commonContent) {
    let base64Content = Buffer.from(commonContent).toString('base64');
    return base64Content;
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/sys_tool/base64.js